/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { Text } from '@atlaskit/primitives/compiled/text';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { EmptyContentMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/empty-content/index.tsx';

const noPlans = defineMessage({
	id: 'navigation-apps-sidebar-nav4-plans.plans.common.empty-content.no-plans',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: "Once you open or create plans, they'll show up here.",
	description: 'Message for no plans in the plans menu items',
});

export function PlansEmptyContent(): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<EmptyContentMenuItem>
			<Text size="small" color="color.text.subtle">
				{formatMessage(noPlans)}
			</Text>
		</EmptyContentMenuItem>
	);
}
